import { createRoute } from "@tanstack/react-router";

import { root } from "routes";

import Layout from "theme/ui/Layout";
import Application from "areas/partners/pages/Application";
import Partner from "areas/partners/pages/Partner";
import Partners from "areas/partners/pages/Partners";

import type { PartnersFilters } from "./models";


const _root = createRoute({
	getParentRoute: () => root,
	path: "partners",
	component: () => <Layout.Light />
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "/",
	component: () => <Partners />,
	validateSearch: () => ({}) as PartnersFilters
});

const application = createRoute({
	getParentRoute: () => _root,
	path: "application/$id",
	component: () => <Application />
});

const partner = createRoute({
	getParentRoute: () => _root,
	path: "$id",
	component: () => <Partner />
});


const partners = _root.addChildren([index, application, partner]);
export default partners;